import React, { useState, useEffect } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import "../Home/table.css"
import { Modal, Button, Form } from 'react-bootstrap';
import ApiService from '../../../EpicGame/services/apiService';

const UserGradeListing = () => {
    const apiService = new ApiService()

    const [formData, setFormData] = useState({
        userName: "",
        phoneNumber: '',
        fromDate: '',
        toDate: '',
    });
    const [continuous, setContinuous] = useState(null);
    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        fetchuser();
    }, []);

    const fetchuser = async () => {
        try {
            // const params = new URLSearchParams();
            // params.append('PageNo', newPageNo || 1);
            // params.append('PageSize', pageSize || 20);
            // const response = await apiService.getApiParamater('GET_CURRENCY_MASTER', `?${params.toString()}`);
            const response = await apiService.get('GET_USER_LEVEL');
            setRowData(response?.data);
        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    };
    const handleReset = () => {
        setFormData({
            userName: "",
            phoneNumber: "",
            fromDate: '',
            toDate: '',
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate' || name === 'toDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleContinuousClick = (user) => {
        setContinuous(user);
    };
    const handleContinuousCloseModal = () => setContinuous(null);
    return (
        <div className='p-5'>
            <div className="table-container mx-4">
                <table className="custom-table ">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Commission</th>
                            <th>Minimum Balance</th>
                            <th>Number of Order Received</th>
                            <th>Number of withDraw</th>
                            <th>Minimum amount of withDraw</th>
                            <th>Maximum amount of withDraw</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.map((row) => (
                            <tr key={row.id}>
                                <td>{row.name}</td>
                                <td>{row.commission}</td>
                                <td>{row.money_hide}</td>
                                <td>{row.order_num}</td>
                                <td>{row.cash_num}</td>
                                <td>{row.cash_min}</td>
                                <td>{row.cash_max}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {/* set continuous single Info Modal */}
            <Modal show={!!continuous} onHide={handleContinuousCloseModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>set continuous single</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {continuous && (
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Current Number of Order made : </Form.Label>
                                <Form.Control readOnly />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Orders Received today</Form.Label>
                                <Form.Control readOnly />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>maximum orders received by level</Form.Label>
                                <Form.Control readOnly />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Start Continuous orders after severa orders</Form.Label>
                                <Form.Control readOnly />
                            </Form.Group>
                            <Form.Group className="mb-3 gap-3">
                                <Form.Label>Products : </Form.Label>
                                <Form.Label className='text-success'> Please select continuous orders in the product list</Form.Label>
                            </Form.Group>
                        </Form>
                    )}
                </Modal.Body>
                <Modal.Footer className='d-flex' >
                    <Button variant="secondary" onClick={handleContinuousCloseModal}>
                        Reset Continuous Orders
                    </Button>
                    <Button variant="primary">OK</Button>
                </Modal.Footer>
            </Modal>
        </div >
    );
};
export default UserGradeListing;